import produce, { current } from 'immer'
import { VARIANT_GROUP_IDS } from '../../components/Shared/Factsheet/constants'
import { getRoomName } from '../../components/Default/Property/Rooms/common'

const initialState = {
  rooms: [],
  roomAttributes: {},
  variantGroups: [
    {
      variantGroupTypeId: VARIANT_GROUP_IDS.ROOMS,
      label: 'Rooms',
      variants: []
    }
  ]
}

const buildVariantsFromRooms = (sortedRooms, roomAttributes) => {
  return sortedRooms.map((room) => {
    return {
      variantId: room.id,
      label: getRoomName(roomAttributes, room)
    }
  }).sort((a, b) => a.label.localeCompare(b.label, 'en'))
}

const sortRooms = (rooms, roomAttributes) => {
  return [...rooms].sort((a, b) => {
    const labelA = getRoomName(roomAttributes, a)
    const labelB = getRoomName(roomAttributes, b)
    return labelA.localeCompare(labelB, 'en')
  })
}

const room = produce((draft = initialState, action) => {
  switch (action.type) {
    case 'ROOMS_PUT':
      const roomAttributes = current(draft).roomAttributes
      const sortedRooms = sortRooms(action.payload.rooms, roomAttributes)
      draft.rooms = sortedRooms
      draft.variantGroups[0].variants = buildVariantsFromRooms(
        sortedRooms, roomAttributes
      )
      return draft
    case 'ROOM_ATTRIBUTES_PUT': {
      draft.roomAttributes = action.payload.roomAttributes
      return draft
    }
    default:
      return draft
  }
})

export default room
